import { useEffect, useState } from "react";

import basePubSub from "pubsub-js";

export const pubSub = {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    publish(topic: string, msg: any): void {
        basePubSub.publish(topic, msg);
    },
};

export const TOPIC_ERROR = "__ERROR__";
export const TOPIC_TOKEN_EXPIRED = "__TOKEN_EXPIRED__";
export const TOPIC_ERROR_DIALOG = "__ERROR_DIALOG__";

export const usePubSub = (): {
    publish: (topic: string, msg: any) => void;
    subscribe: (topic: string, callback: (data: any) => void) => void;
    unsubscribe: (topic: string) => void;
} => {
    const [token, setToken] = useState(null);

    function publish(topic: string, msg: any) {
        basePubSub.publish(topic, msg);
    }

    function subscribe(topic: string, callback: (data: any) => void) {
        const cb = (_topic: string, data: any) => {
            callback(data);
        };
        setToken(basePubSub.subscribe(topic, cb));
    }

    function unsubscribe(topic: string) {
        setToken(basePubSub.unsubscribe(topic));
    }

    useEffect(() => {
        return () => {
            basePubSub.unsubscribe(token);
        };
    }, [token]);

    return {
        publish,
        subscribe,
        unsubscribe,
    };
};
